/**
 * The single place that knows which locales run right-to-left. Nothing else in
 * the codebase branches on direction — the stylesheets use logical properties
 * only, so setting `dir` here mirrors the whole interface.
 */
const RTL_LANGS = new Set(['ar', 'he', 'fa', 'ur', 'ps']);

export function isRtl(lang: string): boolean {
  return RTL_LANGS.has(lang.split('-')[0].toLowerCase());
}

export function applyDocumentDirection(lang: string): void {
  const html = document.documentElement;
  html.lang = lang;
  html.dir = isRtl(lang) ? 'rtl' : 'ltr';
}
